import { createSlice } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";

import { endOfMonth, format, parse, subMonths } from "date-fns";
import { calculatePastDates } from "./dashboard";
const date = new Date();
const firstDay = new Date(date.getFullYear(), date.getMonth(), 1, 1);
const currentDay = new Date(
  date.getFullYear(),
  date.getMonth(),
  date.getDate(),
  1,
);
const lastDayOfMonth = endOfMonth(
  new Date(date.getFullYear(), date.getMonth(), 1),
);

export const initialproductsRelatory = {
  isOpenModalM2: false,
  isOpenModalFormM2: false,
  storeSelectedUpdateM2: {
    _id: null,
  },
  detailProduct: {
    isShow: false,
    pcn_id: "",
    card: {
      selected: "tributario",
    },
  },
  cardAll: {
    dateInit: firstDay,
    dateEnd: lastDayOfMonth,
  },

  cardModalTotalTickets: {
    dateInit: "",
    dateEnd: lastDayOfMonth,
  },
  cardSale: {
    dateInit: firstDay,
    dateEnd: lastDayOfMonth,
    dateInitPast: parse(
      format(subMonths(currentDay, 1), "yyyy-MM-01"),
      "yyyy-MM-dd",
      1,
    ),
    dateEndPast: endOfMonth(subMonths(currentDay, 1)),
  },
  cardCouponsSold: {
    dateInit: firstDay,
    dateEnd: lastDayOfMonth,
    dateInitPast: parse(
      format(subMonths(currentDay, 1), "yyyy-MM-01"),
      "yyyy-MM-dd",
      1,
    ),
    dateEndPast: endOfMonth(subMonths(currentDay, 1)),
  },
  cardSkuMBuy: {
    dateInit: firstDay,
    dateEnd: lastDayOfMonth,
    dateInitPast: parse(
      format(subMonths(currentDay, 1), "yyyy-MM-01"),
      "yyyy-MM-dd",
      1,
    ),
    dateEndPast: endOfMonth(subMonths(currentDay, 1)),
  },
  cardSkuMSale: {
    dateInit: firstDay,
    dateEnd: lastDayOfMonth,
    dateInitPast: parse(
      format(subMonths(currentDay, 1), "yyyy-MM-01"),
      "yyyy-MM-dd",
      1,
    ),
    dateEndPast: endOfMonth(subMonths(currentDay, 1)),
  },
  calcForm: {
    regimeTributario: "LR",
    operation: "INTERNA",
    supplier: "ei",
    sale_in: "sac",
  },
  cardsItem: {
    type_icms_compra: "EI",
    type_icms_venda: "SNC",
  },
  list: [],
  params: {
    page: 1,
    limit: 100,
  },
  columns: [],
  openSelectColumns: false,
  filtersType: "",
  filters: {
    isFilterEanGtin: false,
    divergencia_pis_cofins: [],
    divergencia_icms_e: [],
    divergencia_icms_s: [],
    carga_trib: [],
  },
  removeFilters: "",
  clauseFilters: [],
  taxValues: {
    name: "",
    options: [],
  },
  type: "",
  totalPages: 0,
  modalExportOpen: false,
  defaultExpanded: false,
  export: {
    fileName: "",
    fileType: "",
    columns: [],
  },
  isReview: false,
};

const initialState = () => {
  return initialproductsRelatory;
};

const handleCardTotalTicketsReducer = (state, { payload }) => {
  state.cardModalTotalTickets.dateInit = payload.dateInit;
  state.cardModalTotalTickets.dateEnd = payload.dateEnd;
};

const handleCardSaleReducer = (state, { payload }) => {
  state.cardSale.dateInit = payload.dateInit;
  state.cardSale.dateEnd = payload.dateEnd;

  const { dateInitPast, dateEndPast } = calculatePastDates(payload);
  state.cardSale.dateInitPast = dateInitPast;
  state.cardSale.dateEndPast = dateEndPast;
};

const handleCardCuponsReducer = (state, { payload }) => {
  state.cardCouponsSold.dateInit = payload.dateInit;
  state.cardCouponsSold.dateEnd = payload.dateEnd;

  const { dateInitPast, dateEndPast } = calculatePastDates(payload);
  state.cardCouponsSold.dateInitPast = dateInitPast;
  state.cardCouponsSold.dateEndPast = dateEndPast;
};

const handleCardSkuMBuyReducer = (state, { payload }) => {
  state.cardSkuMBuy.dateInit = payload.dateInit;
  state.cardSkuMBuy.dateEnd = payload.dateEnd;

  const { dateInitPast, dateEndPast } = calculatePastDates(payload);
  state.cardSkuMBuy.dateInitPast = dateInitPast;
  state.cardSkuMBuy.dateEndPast = dateEndPast;
};

const handleCardSkuMSaleReducer = (state, { payload }) => {
  state.cardSkuMSale.dateInit = payload.dateInit;
  state.cardSkuMSale.dateEnd = payload.dateEnd;

  const { dateInitPast, dateEndPast } = calculatePastDates(payload);
  state.cardSkuMSale.dateInitPast = dateInitPast;
  state.cardSkuMSale.dateEndPast = dateEndPast;
};

const handleCardAllDateReducer = (state, payload) => {
  state.cardAll.dateInit = payload?.payload?.dateInit;
  state.cardAll.dateEnd = payload?.payload?.dateEnd;
  handleCardSaleReducer(state, payload);
  handleCardCuponsReducer(state, payload);
  handleCardSkuMBuyReducer(state, payload);
  handleCardSkuMSaleReducer(state, payload);
};

export const productsRelatorySlice = createSlice({
  name: "productsRelatory",
  initialState,
  reducers: {
    handleCardCupons: handleCardCuponsReducer,
    handleCardSale: handleCardSaleReducer,
    handleCardSkuMBuy: handleCardSkuMBuyReducer,
    handleCardSkuMSale: handleCardSkuMSaleReducer,
    handleCardsAll: handleCardAllDateReducer,
    handleCardTotalTickets: handleCardTotalTicketsReducer,
    handleParamsPage: (state, { payload }) => {
      state.params.page = payload.page;
    },
    handleSetList: (state, { payload }) => {
      state.list = [...payload.list];
      state.totalPages = payload.totalPages;
    },
    handleOpenAllItens: (state, { payload }) => {
      state.defaultExpanded = payload;
    },
    handleSetFilterField: (state, { payload }) => {
      const { name } = payload;

      state.filters[name] = payload?.value ?? [];
    },
    handleRemoveFilterField: (state, { payload }) => {
      const { name, value } = payload;
      state.filters[name] = value;
    },
    handleSetColumns: (state, { payload }) => {
      state.columns = payload;
    },
    handleOpenModalExport: (state, { payload }) => {
      state.modalExportOpen = payload;
    },
    handleEnableColumns: (state, { payload }) => {
      const list = [...state.columns];
      list[payload?.key + 1].omit = payload?.omit;
      state.columns = [...list];
    },
    handleSetTypeFilter: (state, { payload }) => {
      state.filtersType = payload?.type;
    },
    handleOpenSelectColumns: (state, { payload }) => {
      state.openSelectColumns = payload;
    },

    handleAddAllExportColumns: (state, { payload }) => {
      const checkExistent = (state.export.columns || []).map(item => item);
      if (checkExistent.length > 0) {
        state.export.columns = [];
      }
      state.export.columns = payload;
    },

    handleAddColumns: (state, { payload }) => {
      const checkExistent = state.export.columns.filter(
        item => item?.sortField === payload?.item?.sortField,
      );

      if (checkExistent?.length > 0) {
        const newList = (state.export.columns || [])
          .filter(item => item?.sortField !== payload?.item?.sortField)
          .map(item => item);

        state.export.columns = [...newList];
      }

      if (!checkExistent?.length) {
        const itemAdd = {
          name: payload?.item?.name,
          sortField: payload?.item?.sortField,
        };

        state.export.columns = [...state.export.columns, itemAdd];
      }
    },
    // TODO: STATE MODAL
    handleOpenDetailProduct: (state, { payload }) => {
      state.detailProduct.pcn_id = payload?.pcn_id;
      state.detailProduct.show = payload?.show;
    },

    handleSetNewCard: (state, { payload }) => {
      state.detailProduct.card.selected = payload.selected;
    },
    handleSetCalcForm: (state, { payload }) => {
      if (payload?.type !== undefined) state.calcForm.regimeTributario = payload.type;
      if (payload?.operation !== undefined) state.calcForm.operation = payload.operation;
      if (payload?.supplier !== undefined) state.calcForm.supplier = payload.supplier;
      if (payload?.saleIn !== undefined) state.calcForm.sale_in = payload.saleIn;
    },
    handleSetCalcFormSupplier: (state, { payload }) => {
      state.calcForm.supplier = payload?.supplier;
    },
    handleSetCalcFormSaleIn: (state, { payload }) => {
      state.calcForm.sale_in = payload?.saleIn;
    },
    handleSetTypeCards: (state, { payload }) => {
      if (payload?.type === "compra") {
        state.cardsItem.type_icms_compra = payload?.value;
      }
      if (payload?.type === "venda") {
        state.cardsItem.type_icms_venda = payload?.value;
      }
      if (payload?.type === "addings") {
        state.cardsItem.type_icms_venda_addings = payload?.value;
      }
    },
    handleSetOpenModalM2: (state, { payload }) => {
      state.isOpenModalM2 = payload;
    },
    handleSetOpenModalFormM2: (state, { payload }) => {
      state.isOpenModalFormM2 = payload;
    },
    handleSelectedStoreUpdateM2: (state, { payload }) => {
      state.storeSelectedUpdateM2._id = payload?.id;
    },
    handleAddFilters: (state, { payload }) => {
      state.clauseFilters = payload;
    },
    handleRemoveFilterUnic: (state, action) => {
      const { id } = action.payload;
      state.clauseFilters = state.clauseFilters.filter(item => item.id !== id);
    },
    handleOnChangeFilter: (state, { payload }) => {
      const list = [...state.clauseFilters];
      list[payload?.key].columnField[payload?.field] = payload?.value;
      state.clauseFilters = list;
    },
    handleRemoveFilterAll: state => {
      state.clauseFilters = [
        {
          id: uuidv4(),
          columnField: {
            columnOrField: "and",
            columnField: "prod_nome",
            operatorValue: "equals",
            value: "",
          },
        },
      ];
    },
    handleSetPageAndLimit: (state, { payload }) => {
      if (payload.page) {
        state.page = payload.page;
      }
      if (payload.type) {
        state.type = payload.type;
      }
      if (payload.totalPages) {
        state.totalPages = payload.totalPages;
      }
      if (payload.limit) {
        state.limit = payload.limit;
      }
      if (payload.currentMonth) {
        state.currentMonth = payload.currentMonth;
      }
    },
    handleSetOptionsValue: (state, { payload }) => {
      state.taxValues.name = payload.name;
      state.taxValues.options = payload.options;
    },
    handleSetIsReview: (state, { payload }) => {
      state.isReview = payload;
    },
  },
});

export const {
  handleParamsPage,
  handleSetList,
  handleAddAllExportColumns,
  handleAddColumns,
  handleSetTypeFilter,
  handleSetColumns,
  handleOpenSelectColumns,
  handleEnableColumns,
  handleOpenModalExport,
  handleSetFilterField,
  handleRemoveFilterField,
  handleOpenAllItens,
  handleOpenDetailProduct,
  handleSetNewCard,
  handleSetCalcForm,
  handleSetCalcFormSupplier,
  handleSetCalcFormSaleIn,
  handleSetOpenModalM2,
  handleSetOpenModalFormM2,
  handleSetTypeCards,
  handleCardsAll,
  handleCardSale,
  handleCardCupons,
  handleCardSkuMBuy,
  handleCardSkuMSale,
  handleCardTotalTickets,
  handleSelectedStoreUpdateM2,
  handleAddFilters,
  handleRemoveFilterUnic,
  handleOnChangeFilter,
  handleRemoveFilterAll,
  handleSetPageAndLimit,
  handleSetOptionsValue,
  handleSetIsReview,
} = productsRelatorySlice.actions;

export default productsRelatorySlice.reducer;
